// React
import React from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {UploadDataFleetAction} from './actions';
import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {Button, Typography, Grid} from '@material-ui/core';

// Type
import {Props} from './interfaces';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      display: 'none',
    },
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
  })
);

function UploadInfo(props: Props) {
  const classes = useStyles();

  const handleUploadClick = (e: any) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const formData: FormData = new FormData();

    reader.onloadend = function (e) {
      formData.append('file', file);
      props.UploadDataFleetDispach(formData);
    };
  };
  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography variant="h4" component="h2">
            {'بارگذاری اطلاعات'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" component="div">
            {'برای اضافه کردن ناوگان جدید، فایل اکسل خود را بارگذاری کنید'}
          </Typography>
        </Grid>
        <Grid container item xs={12} sm={6} direction="row-reverse">
          <input
            accept=".xlsx, .xls, .csv,"
            className={classes.input}
            id="contained-button-file"
            multiple
            type="file"
            onChange={handleUploadClick}
          />
          <label htmlFor="contained-button-file">
            <Button
              fullWidth
              variant="contained"
              color="primary"
              component="span"
              size="large"
            >
              {'بارگذاری'}
            </Button>
          </label>
        </Grid>
        <Grid item xs={5}>
          <p>
            اطلاعات خودروها را با فرمت CSV و مطابق این &nbsp;{' '}
            <a href="/Vehicles.csv" target="_blank">
              نمونه
            </a>
            &nbsp; ثبت نمایید. دقت کنید که Microsoft Excel در نمایش و ثبت فرمت
            CSV با رمزگذاری UTF-8 مشکل دارد. می‌توانید از Google Sheets یا
            نرم‌افزارهای دیگر برای ویرایش و ذخیره‌سازی فایل CSV استفاده کنید.
            ستون‌های CSV حاوی اطلاعات زیر است:
          </p>
          <ul>
            <li>نام ناوگانی که خودرو در آن قرار دارد</li>
            <li>اطلاعات خودرو</li>
            <li>اطلاعات راننده</li>
            <li>شیفت راننده</li>
            <li>مراکز مطلوب فعالیت راننده</li>
          </ul>
          <p>نکات زیر را در هنگام وارد کردن اطلاعات مد نظر قرار دهید:</p>
          <ul>
            <li>کلاس خودرو را براساس سه مقدار پیش‌فرض مشخص شده وارد کنید</li>
            <li>سال تولید خودرو و سال تولد راننده را به شمسی وارد کنید</li>
            <li>تاریخ شروع به کار راننده را به میلادی وارد کنید</li>
            <li>
              شیفت راننده یک رشته به طول ۲۴×۷ است که هر واحد آن یا ۰ (در دسترس
              نبودن) یا ۱ (در دسترس بودن) راننده را در ساعات هفته نشان می‌دهد
            </li>
            <li>مراکز مطلوب فعالیت راننده را با / از هم جدا کنید</li>
          </ul>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, any>({});

function mapDispatchToProps(dispatch: Function) {
  return {
    UploadDataFleetDispach: (payload: FormData) =>
      dispatch(UploadDataFleetAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(UploadInfo);
